App.namespace.wrap('es6.shared.in_view_test_function', function (element, options) {
  //is hidden or any parent it's hidden
  //helpful on mobile to never load images that are hidden
  if (element.offsetParent === null) {
    return false;
  }

  let OFFSET = options.offset.top;

  // If user is on top of the screen load just the minimum - current screen
  // plus 100px surroundings
  if (window.scrollY === 0) {
    OFFSET = -100;
  }

  //all below is original handler copied from default inView function
  //https://github.com/camwiegert/in-view/blob/7b835d0450427dee6ad009cf407ca6116b5b5bf1/src/in-view.js
  const { top, bottom, height } = element.getBoundingClientRect();

  const intersection = {
    t: bottom,
    b: window.innerHeight - top
  };

  const threshold = options.threshold * height;

  return intersection.t > (OFFSET + threshold)
    && intersection.b > (OFFSET + threshold);
});
